import React from "react";
import { iconProps } from "../../Helper";

export const ImageSuiteIcon = ({ className, size }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size?size:"60"}
      height={size?size:"60"}
      viewBox="0 0 81 81"
      fill="none"
    >
      <mask
        id="mask0_13366_105684"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="81"
        height="81"
      >
        <rect x="0.775391" y="0.863281" width="80" height="80" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13366_105684)">
        <path
        className={className}
          d="M18.4682 69.196C16.7843 69.196 15.359 68.6126 14.1924 67.446C13.0257 66.2793 12.4424 64.854 12.4424 63.1701V18.5551C12.4424 16.8712 13.0257 15.446 14.1924 14.2793C15.359 13.1126 16.7843 12.5293 18.4682 12.5293H63.0832C64.7671 12.5293 66.1924 13.1126 67.3591 14.2793C68.5257 15.446 69.109 16.8712 69.109 18.5551V63.1701C69.109 64.854 68.5257 66.2793 67.3591 67.446C66.1924 68.6126 64.7671 69.196 63.0832 69.196H18.4682ZM18.4682 64.196H63.0832C63.3399 64.196 63.5749 64.089 63.7882 63.8751C64.0021 63.6618 64.109 63.4268 64.109 63.1701V18.5551C64.109 18.2985 64.0021 18.0635 63.7882 17.8501C63.5749 17.6362 63.3399 17.5293 63.0832 17.5293H18.4682C18.2115 17.5293 17.9766 17.6362 17.7632 17.8501C17.5493 18.0635 17.4424 18.2985 17.4424 18.5551V63.1701C17.4424 63.4268 17.5493 63.6618 17.7632 63.8751C17.9766 64.089 18.2115 64.196 18.4682 64.196ZM23.2757 56.696H58.5316L47.5707 42.081L38.2116 54.2601L31.5449 45.7343L23.2757 56.696Z"
        />
      </g>
    </svg>
  );
};
